import styled from 'styled-components';
import { spacing, size, Title, color } from './';

export const ModalContent = styled.section`
  color: ${color('blue', 'dark')};

  img {
    display: block;
    max-width: 100%;
  }

  strong {
    font-weight: 600;
  }
`;

export const ModalBody = styled.div`
  padding: ${spacing()};
`;

export const ModalHeader = styled.header`
  text-align: center;
  background-color: #fff;

  ${props =>
    props.padded &&
    `
    padding: ${spacing()};
  `};
`;

export const ModalTitle = styled.h1`
  font-size: ${size(2)};
  margin-top: ${spacing()};
  margin-bottom: 0;
`;

export const ModalSubtitle = styled(Title)`
  margin-top: ${props => (props.marged ? spacing(2) : spacing())};
`;

export const ModalSection = styled.div`
  + div {
    margin-top: ${spacing(2)};
  }
`;
